import './components/header';
import './components/map';
import './components/room-list';

function hidePreloader() {
    document.body.classList.add('loaded');
}

// addEventListener instead of window.onload: WP Rocket "Delay JS" can override window.onload.
window.addEventListener('load', function () {
    window.setTimeout(hidePreloader, 500);
});

// Fallback in case "load" never fires (e.g. a hanging resource).
window.setTimeout(hidePreloader, 8000);
